import {
  Button as MUIButton,
  Checkbox as MUICheckbox,
  CircularProgress as MUICircularProgress,
  Dialog as MUIDialog,
  FormControlLabel as MUIFormControlLabel,
} from '@material-ui/core';
import { CreateCSSProperties, withStyles } from '@material-ui/styles';

import styled from 'styled-components';

export const Dialog = withStyles(() => ({
  root: {
    '& .MuiDialog-paper': {
      fontFamily: "'Poppins Regular'",
      fontSize: '1rem',
      padding: '1.5rem',
      lineHeight: '1.5rem',
      color: '#000',
      gap: '1.5rem',
      overflow: 'hidden',
      minWidth: '800px',
    },
    '& .MuiDialogTitle-root': {
      padding: '0',
      '& .MuiTypography-root': {
        fontFamily: "'Poppins Medium'",
        fontSize: '1.375rem',
        lineHeight: '2rem',
        color: '#000',
      },
    },
    '& .MuiDialogContent-root': {
      padding: '0',
      width: '100%',
      float: 'left',
      display: 'flex',
      flexDirection: 'column',
      lineHeight: '1.5',
    },
    '& p': {
      margin: 0,
    },
  },
}))(MUIDialog);

const bottomButtonsStyles: CreateCSSProperties<{}> = {
  height: '2.5rem',
  fontSize: '0.875rem',
  fontFamily: 'Poppins Medium',
  fontWeight: 500,
  textTransform: 'none',
  boxShadow: 'none',
  padding: '0 1.5rem',
};

export const ConfirmButton = withStyles(() => ({
  root: {
    ...bottomButtonsStyles,
    color: '#FFF',
    width: '120px',
  },
}))(MUIButton);

export const LoadingButtonInfo = withStyles(() => ({
  root: {
    width: '26px !important',
    height: '26px !important',
    color: 'inherit',
  },
}))(MUICircularProgress);

export const CheckboxItem = withStyles({
  root: {
    gap: '0.5rem',
    margin: '0',
    '& > .MuiFormControlLabel-label': {
      fontFamily: "'Poppins Medium'",
      fontSize: '0.875rem',
      color: '#000',
    },
  },
})(MUIFormControlLabel);

export const Checkbox = withStyles({
  root: { padding: '0' },
})(MUICheckbox);

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`;

export const ScrollContent = styled('div')`
  max-height: 400px;
`;

export const ConfirmButtonBox = styled('div')`
  display: flex;
  justify-content: flex-end;
`;
